<template lang='pug'>
	.pleca-verde-overlay
		b-modal#modal1(ref='myModalRef' hide-footer size="lg" title="")
			pop
			.content-btn( style="width: 100%; display: flex; justify-content:center;")
				b-button.mt-3(variant="outline-success" style="padding: 3px 40px; " @click="hideModal") Close

		.contenedor-headerImageShort
			.contenido
				.modulo.modulo-1
					b-link.link-pleca-verde(to='/compliance-wizard')
						img(src='~Img/assignment_turned_in-material.png')
						p
							span
								| Is Title 24 Compliance Required for my Project?
				.modulo.modulo-2
					.ico
						b-link.link-pleca-verde(@click='showModal' style="color: white; text-decoration: none;" )
							img.icono1(src='~Img/baseline-help_outline-24px.svg')
							p
								span
									| Should I do this myself?
				.modulo.modulo-3
					app-link.link-pleca-verde(:to="navLinks.newProject")
						img(src='~Img/business-material.png')
						p
							span
								| Take a Test Drive, Create a new Project
</template>
<script>
import pop from './pop/ShouldIdoMySelf'
export default {
	name: 'green-bar',
	data: function () {
		return {
			navLinks: {}
		}
	},
	components: {
		pop
	},
	beforeMount: function () {
		this.navLinks = this.$e24Common.storageService.findItem('navLinks', true)
		// console.debug('NavBar config', this.navLinks)
	},
	methods: {
		showModal () {
			this.$refs.myModalRef.show()
		},
		hideModal () {
			this.$refs.myModalRef.hide()
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/doit/greenBarOverlay.vue